export const SECTIONS = {
  AWARDS_PRESS: 'awards-press',
};
